import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const useStyles = makeStyles(() => ({
	salesCrmCarousel: {
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		paddingBottom: "65px",
		"& .header-section": {
			flexDirection: "column",
			width: "55%",
			"& h2": {
				marginBottom: "32px",
			},
			"& p": {
				marginBottom: "0",
			},
			"@media(max-width:768px)": {
				width: "100%",
				"& h2": {
					marginBottom: "20px",
				},
			},
		},
		"@media only screen and (max-width: 1024px)": {
			paddingBottom: "60px",
		},
		"@media only screen and (max-width: 768px)": {
			paddingBottom: "50px",
		},
		"@media only screen and (max-width: 600px)": {
			paddingBottom: "40px",
		},
		"@media only screen and (max-width: 480px)": {
			paddingBottom: "30px",
		},
	},

	adaptSlider: {
		width: "100%",
		"& .swiper-wrapper": {
			alignItems: "stretch",
			padding: "16px 8px",
		},
	},

	adaptsBox: {
		gap: "24px",
		display: "flex !important",
		padding: "24px",
		background: "#fff",
		alignItems: "stretch",
		borderRadius: "16px",
		flexDirection: "column",
		justifyContent: "flex-start",
		boxShadow: "0px 0px 24px #D4E0E9",
		height: "auto !important",
		"@media only screen and (max-width: 1024px)": {
			padding: "20px",
			maxWidth: "350px",
			gap: "14px",
		},
		"@media only screen and (max-width: 768px)": {
			padding: "18px",
			maxWidth: "320px",
			gap: "12px",
		},
		"@media only screen and (max-width: 600px)": {
			padding: "15px",
			maxWidth: "80%",
			gap: "15px",
		},
		"@media only screen and (max-width: 480px)": {
			padding: "12px",
			maxWidth: "85%",
			gap: "10px",
		},
	},

	adaptBoxHeader: {
		display: "flex",
		alignItems: "center",
		gap: "12px",
	},

	adaptDescription: {
		gap: "10px",
		minHeight: "80px",
		display: "flex",
		alignItems: "flex-start",
		"@media only screen and (max-width: 1024px)": {
			minHeight: "70px",
		},
		"@media only screen and (max-width: 768px)": {
			minHeight: "60px",
		},
		"@media only screen and (max-width: 600px)": {
			alignItems: "baseline",
			minHeight: "auto",
		},
	},

	adaptBoxImg: {
		width: "48px",
		maxWidth: "48px",
		marginBottom: "24px",
		"@media only screen and (max-width: 1024px)": {
			width: "44px",
			maxWidth: "44px",
			marginBottom: "20px",
		},
		"@media only screen and (max-width: 768px)": {
			width: "40px",
			maxWidth: "40px",
			marginBottom: "18px",
		},
		"@media only screen and (max-width: 600px)": {
			width: "36px",
			maxWidth: "36px",
			marginBottom: "16px",
		},
		"@media only screen and (max-width: 480px)": {
			width: "32px",
			maxWidth: "32px",
			marginBottom: "14px",
		},
	},
}));

const SalesCrmCarousel = ({ title, subtitle, slides, backgroundImage }) => {
	const classes = useStyles();

	return (
		<section
			className={classes.salesCrmCarousel}
			style={{
				backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<div className="container">
				<div className="header-section">
					<motion.h2
						className="font-wix-semibold font-56 color-black1"
						initial={{ opacity: 1, y: 20 }}
						transition={{ duration: 0.3 }}
						whileInView={{ opacity: 1, y: 0 }}
					>
						{title}
					</motion.h2>
					<motion.p
						className="font-wix-regular font-18 color-black2"
						initial={{ opacity: 1, y: 20 }}
						transition={{ duration: 0.3 }}
						whileInView={{ opacity: 1, y: 0 }}
					>
						{subtitle}
					</motion.p>
				</div>
			</div>

			<Swiper
				autoplay={{
					delay: 0,
					disableOnInteraction: false,
				}}
				breakpoints={{
					0: {
						slidesPerView: 1,
						centeredSlides: true,
						freeMode: true,
						spaceBetween: 15,
						slidesPerGroup: 1,
					},
					768: {
						slidesPerView: 2,
						slidesPerGroup: 1,
						spaceBetween: 15,
						centeredSlides: true,
					},
					1024: {
						slidesPerView: 4,
						slidesPerGroup: 1,
						spaceBetween: 15,
					},
				}}
				className={classes.adaptSlider}
				grabCursor={true}
				loop={true}
				modules={[Autoplay]}
				spaceBetween={30}
				speed={5000}
			>
				{slides.map((point, index) => (
					<SwiperSlide className={classes.adaptsBox} key={index}>
						<div className={classes.adaptBoxHeader}>
							<img alt={point.pointer || "slide image"} className={classes.adaptBoxImg} src={point.img} />
							<p className="font-24 font-wix-semibold lineHeight-1">{point.pointer}</p>
						</div>
						<div className={classes.adaptDescription}>
							<p className="font-wix-regular font-18">{point.desc}</p>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</section>
	);
};

export default SalesCrmCarousel;
